module.exports = __webpack_public_path__ + "img/a.f6d51c2a.jpg";